<script lang="ts">
  import { getCopy } from "../../lib/stores/copy";
  import LanguageItem from "./LanguageItem.svelte";
  import { getNamedLanguages } from "../../lib/helpers/language";

  export let onSelect: () => void = () => "do nothing";

  $: languages = getNamedLanguages($getCopy("languages", { basePath: "", defaultReturnValue: ["en"] }) as string[]);
</script>

{#each languages as language}
  <LanguageItem isoCode={language} {onSelect} />
{/each}
